// extracted by mini-css-extract-plugin
export default {"root":"ViewProperty_root__GJc4j","header":"ViewProperty_header__6Mlw2"};